import React from 'react';
import { CreditCardIcon, MapPinIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const reasons = [{
  icon: CreditCardIcon,
  title: 'Precio en pesos mexicanos',
  text: 'Pagas en pesos mexicanos. Si compras desde otro país, el cobro se convierte a tu moneda al tipo de cambio del momento.'
}, {
  icon: MapPinIcon,
  title: 'Pensado para México',
  text: 'Bocadillos, precios de referencia y trámites de México. Si estás en otro país, aplicas las recetas, los menús y el costeo con tus propios precios.'
}];
export function WhyGlobal() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="moneda-title" data-id="element-235" data-mp="3biqy596065tj">
      <div className="mx-auto max-w-5xl px-6" data-id="element-236" data-mp="3gcbw517lizsq">
        <Reveal className="text-center" data-id="element-237" data-mp="3lb6czxm06ea7">
          <h2 id="moneda-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-238" data-mp="3la3nnu4bwjwe">
            Compras desde donde estés
          </h2>
        </Reveal>

        <ul className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-239" data-mp="3uajqr2h5tp0q">
          {reasons.map((reason, index) => <li key={reason.title} className="flex" data-id="element-240" data-mp="2d3ze4xtroi6a" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full gap-4 rounded-2xl bg-sand p-7 ring-1 ring-inset ring-cream-line" data-id="element-241" data-mp="2d1d4msnbfslf">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-mint-700 text-white" aria-hidden="true" data-id="element-242" data-mp="234qkk62td5kg">
                  <reason.icon className="h-5 w-5" data-id="element-243" data-mp="1y7qgg0piycvz" />
                </span>
                <div data-id="element-244" data-mp="2vsw62v1oyylc">
                  <h3 className="font-display text-xl text-ink" data-id="element-245" data-mp="2vteeeq1mp39m">{reason.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-246" data-mp="2qw5ryd9g6d2k">{reason.text}</p>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}